import { Component, EventEmitter, Input, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Computer } from 'src/app/models/computer';
import { SettingsService, Unit } from 'src/app/services/account/settings.service';
import { UtilsService } from 'src/app/services/utils/utils.service';
import { TurnValueIntegerPipe } from 'src/app/pipes/turn-value-integer.pipe';
import { TurnValueIntegerThousandsPipe } from 'src/app/pipes/turn-value-integer-thousands.pipe';

@Component({
  standalone: true,
  selector: 'app-navigation-plan-row',
  templateUrl: './navigation-plan-row.component.html',
  styleUrls: ['./navigation-plan-row.component.scss'],
  imports: [CommonModule, TurnValueIntegerPipe, TurnValueIntegerThousandsPipe]
})
export class NavigationPlanRowComponent {
  @Input() computer: Computer | null = null;
  @Output() batteryReservedWarningClick = new EventEmitter<void>();

  constructor(public settingsService: SettingsService, private utilsService: UtilsService) {}

  public showMetricMeter(m: number): boolean {
    return m < 1000 && this.settingsService.getUnit().Distance == Unit.Metric;
  }

  public showMetricKMeter(m: number): boolean {
    return m >= 1000 && this.settingsService.getUnit().Distance == Unit.Metric;
  }

  public showImperialYard(m: number): boolean {
    return this.utilsService.mToYard(m) < 1760 && this.settingsService.getUnit().Distance == Unit.Imperial;
  }

  public showImperialMile(m: number): boolean {
    return this.utilsService.mToYard(m) >= 1760 && this.settingsService.getUnit().Distance == Unit.Imperial;
  }

  public openWarning(event: Event): void {
    event.stopPropagation();
    this.batteryReservedWarningClick.emit();
  }
}
